import { Component, computed, signal } from '@angular/core'

import { FormsModule } from '@angular/forms'
import { EntityRef, EntityRefWithUID } from 'src/app/shared/models/referenceData'
import { DateRangeFilterStateValue } from 'src/app/shared/services/filter/date-range-filter'
import { DateRangeFilterPickerComponent } from '../date-range-filter-picker/date-range-filter-picker.component'
import { EntitySelectorComponent } from '../entity-selector/entity-selector.component'
import { LabeledPropertyComponent } from '../labeled-property/labeled-property.component'
import { ModalBodyComponent } from '../modals/modal-body/modal-body.component'
import { ModalFooterComponent } from '../modals/modal-footer/modal-footer.component'
import { ModalHeaderComponent } from '../modals/modal-header/modal-header.component'
import { TBillRetailerUsageOverrideCreateRequest } from '../settlements/tbill-settlements.types'
import { NumberInputComponent } from '../number-input/number-input.component'

@Component({
  imports: [
    FormsModule,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    LabeledPropertyComponent,
    DateRangeFilterPickerComponent,
    EntitySelectorComponent,
    NumberInputComponent,
  ],
  selector: 'app-create-tbill-retailer-usage-override-modal',
  styles: '',
  template: `
    <div app-modal-header>Create Override</div>

    <div app-modal-body>
        <div app-labeled-property label="Retailer">
            <div
            app-entity-selector
            [slim]="true"
            label="Retailer"
            [config]="{
                resource: 'retailers', 
                allowMultiple: false
            }"
            [value]="modalState().retailer"
            (valueChange)="updateRetailer($event)"
            ></div>
        </div>
        <div app-labeled-property label="Market Interval">
            <div dateRangeFilterPicker
            [value]="modalState().market_interval"
            (valueChange)="updateMarketInterval($event)"
            [showOperation]="false"
            [showRange]="false"
            [showTime]="false"
            [showSeconds]="false"
            [onlyMonth]="true"
            ></div>
        </div>
        <div app-labeled-property label="Usage (kW\u00A0h)">
            <div app-number-input [value]="this.modalState().measurement_value ?? 0" (valueChange)="this.updateMeasurementValue($event)"></div>
        </div>
    </div>

    <div app-modal-footer>
        <button
        class="action-btn primary"
        [disabled]="!canCreate()"
        (click)="create()"
        >
        Create
        </button>
        <button class="action-btn" (click)="onCancel()()">Cancel</button>
    </div>
    `,
})
export class CreateTBillRetailerUsageOverrideModalComponent {
  protected readonly modalState = signal<Partial<{ market_interval: DateRangeFilterStateValue, retailer: EntityRef, measurement_value: number }>>({})
  protected readonly onCreate = signal<(req: TBillRetailerUsageOverrideCreateRequest) => void>(() => void 0)
  protected readonly onCancel = signal<() => void>(() => void 0)

  canCreate = computed(() => {
    const state = this.modalState()
    return state.market_interval &&
            state.retailer &&
            (
              !Number.isNaN(this.modalState().measurement_value) &&
                this.modalState().measurement_value !== null &&
                this.modalState().measurement_value !== undefined
            )
  })

  init(overrides: Partial<{
    modalState: Partial<{ market_interval: DateRangeFilterStateValue, retailer: EntityRef, measurement_value: number }>,
    onCreate: (req: TBillRetailerUsageOverrideCreateRequest) => void,
    onCancel: () => void
  }>) {
    this.modalState.update(v => overrides.modalState ?? v)
    this.onCreate.update(v => overrides.onCreate ?? v)
    this.onCancel.update(v => overrides.onCancel ?? v)
  }

  updateMarketInterval(market_interval: DateRangeFilterStateValue) {
    this.modalState.update(v => ({ ...v, market_interval }))
  }
  updateRetailer(retailer: EntityRef) {
    this.modalState.update(v => ({ ...v, retailer }))
  }
  updateMeasurementValue(measurement_value: number) {
    this.modalState.update(v => ({ ...v, measurement_value }))
  }
  create() {
    this.onCreate()({
      market_interval: this.modalState().market_interval!.value as Date,
      retailer_uid: (this.modalState().retailer! as EntityRefWithUID).entity_uid,
      measurement_value: this.modalState().measurement_value!,
    })
  }
}
